import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button
} from '@mui/material';

import {
  DeleteOutlined,
  DrawOutlined,
  SaveOutlined
} from '@mui/icons-material';

import {
  deleteButtonSx,
  eSignButtonSx,
  saveButtonSx
} from '../../../../../Common/components/Styles/InputStyles';

import { footerSx } from './SoapEntryStyles';

const SoapFooterActions = ({
  disabled,
  onSave,
  onSaveAndSign
}) => {
  return (
    <Box sx={footerSx}>
      <Button
        variant="outlined"
        disabled={disabled}
        size="small"
        startIcon={<DeleteOutlined />}
        sx={deleteButtonSx}>
        Delete
      </Button>

      <Button
        variant="contained"
        disabled={disabled}
        size="small"
        startIcon={<SaveOutlined />}
        sx={saveButtonSx}
        onClick={onSave}>
        Save
      </Button>

      <Button
        variant="contained"
        disabled={disabled}
        size="small"
        startIcon={<DrawOutlined />}
        sx={eSignButtonSx}
        onClick={onSaveAndSign}>
        Save &amp; E-Sign
      </Button>
    </Box>
  );
};

SoapFooterActions.propTypes = {
  disabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onSaveAndSign: PropTypes.func.isRequired
};

export default SoapFooterActions;